(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector('.announcement-bar__slider');
  const slides = document.querySelectorAll('.announcement-bar__item');
  let currentSlide = 0;
  let autoSlideInterval;

  const setPosition = () => {
    slider.style.transform = `translateX(-${currentSlide * 100}%)`;
  };

  const startAutoSlide = () => {
    autoSlideInterval = setInterval(() => {
      currentSlide = (currentSlide + 1) % slides.length;
      setPosition();
    }, 10000);
  };

  const stopAutoSlide = () => clearInterval(autoSlideInterval);

  // Start auto slide when the DOM is loaded
  startAutoSlide();

  // Prevent drag or swipe functionality
  slider.addEventListener('mousedown', (event) => event.preventDefault());
  slider.addEventListener('touchstart', (event) => event.preventDefault());
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
 $('.gallery-pop').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      mainClass: 'mfp-img-mobile',
      image: {
        verticalFit: true
      }

    });

  } catch(e) { console.error(e); }
})();
})();
